var cameras = [{
    "key": "B016F3M7OM",
    "category": "camera",
    "name": "YI Home Camera Wireless IP Security Surveillance System (US Edition) White",
    "seller": "YI",
    "wholePrice": "39",
    "priceFraction": "99",
    "stock": 48,
    "star": 4,
    "starCount": 985,
    "img": "https://images-na.ssl-images-amazon.com/images/I/314hcoZg2JL._AC_US218_.jpg",
    "url": "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_atf_electronics_sr_pg1_1?ie=UTF8&adId=A03127032JGFCK6OPGZQ9&url=https%3A%2F%2Fwww.amazon.com%2FYI-Wireless-Security-Surveillance-US%2Fdp%2FB016F3M7OM%2Fref%3Dsr_1_1%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124549%26sr%3D1-1-spons%26keywords%3Dcamera%26psc%3D1&qualifier=1499124549&id=8228299164163419&widgetName=sp_atf",
    "features": [{
        "description": "Connectivity Technology",
        "value": "wi-fi ready"
    }, {
        "description": "Wireless Communication Technology",
        "value": "Wireless"
    }],
    "price": 39.99,
    "shipping": 3.99
}, {
    "key": "B01MQ0FSS0",
    "category": "camera",
    "name": "Sony Cyber-Shot DSC-RX100 Digital Camera + 64GB SDXC Memory Dual Battery Kit + Accessory Bundle",
    "seller": "Beach Camera",
    "wholePrice": "499",
    "priceFraction": "00",
    "stock": 52,
    "star": 4,
    "starCount": 128,
    "img": "https://images-na.ssl-images-amazon.com/images/I/61T6hxWFVlL._AC_US218_.jpg",
    "url": "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_atf_electronics_sr_pg1_2?ie=UTF8&adId=A05196583793V13Q2RYYJ&url=https%3A%2F%2Fwww.amazon.com%2FCyber-Shot-DSC-RX100-Digital-Camera-Accessory%2Fdp%2FB01MQ0FSS0%2Fref%3Dsr_1_2%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124549%26sr%3D1-2-spons%26keywords%3Dcamera%26psc%3D1&qualifier=1499124549&id=8228299164163419&widgetName=sp_atf",
    "features": [],
    "price": 499,
    "shipping": 3.99
}, {
    "key": "B01KVIN26O",
    "category": "camera",
    "name": "Cell Phone Camera Lens - TURATA 2 in 1 Professional HD Camera Lens Kit 0.45X Super Wide Angle & 12.5X Macro Lens for iPhone7 6s 6s plus 6 plus 5s & Most Smartphone, Tablet",
    "seller": "TURATA",
    "wholePrice": "11",
    "priceFraction": "98",
    "stock": 51,
    "star": 4,
    "starCount": 1011,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41wyZE9sWLL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Cell-Phone-Camera-Lens-Professional/dp/B01KVIN26O/ref=sr_1_3?s=electronics&ie=UTF8&qid=1499124549&sr=1-3&keywords=camera",
    "features": [{
        "description": "Display Dimensions",
        "value": "37mm"
    }, {
        "description": "Special Feature",
        "value": "Fit for most smartphones."
    }],
    "price": 11.98,
    "shipping": 3.99
}, {
    "key": "B00UV6I8QQ",
    "category": "camera",
    "name": "Nikon Coolpix L340 20.2MP Digital Camera with 28x Optical Zoom",
    "seller": "Nikon",
    "wholePrice": "148",
    "priceFraction": "00",
    "stock": 7,
    "star": 3,
    "starCount": 1560,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41VVqVvKuNL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Nikon-Coolpix-L340-Digital-Optical/dp/B00UV6I8QQ/ref=sr_1_4?s=electronics&ie=UTF8&qid=1499124549&sr=1-4&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "7.6 inches"
    }, {
        "description": "Computer Memory Size",
        "value": "43.0 MB"
    }, {
        "description": "Hardware Interface",
        "value": "audio video port"
    }, {
        "description": "Special Feature",
        "value": "image-stabilization"
    }],
    "price": 148,
    "shipping": 3.99
}, {
    "key": "B00W68DSWQ",
    "category": "camera",
    "name": "Nikon COOLPIX L340 Digital Camera with 28x Zoom & Full HD Video (Black) International Version + 4 AA Batteries & Charger + 32GB Dlx Accessory Kit w/HeroFiber Cleaning Cloth",
    "seller": "HeroFiber",
    "wholePrice": "239",
    "priceFraction": "99",
    "stock": 16,
    "star": 4,
    "starCount": 4472,
    "img": "https://images-na.ssl-images-amazon.com/images/I/61yFYo02UzL._AC_US218_.jpg",
    "url": "https://www.amazon.com/International-Batteries-Accessory-HeroFiber-Cleaning/dp/B00W68DSWQ/ref=sr_1_5?s=electronics&ie=UTF8&qid=1499124549&sr=1-5&keywords=camera",
    "features": [],
    "price": 239.99,
    "shipping": 7.99
}, {
    "key": "B01N6E66RN",
    "category": "camera",
    "name": "Aberg Best 18 mega pixels HD Digital Camera - Digital video camera - Students cameras - Students Camcorder - Handheld Sized Digital Camcorder Indoor Outdoor for Adult /Seniors / Kids (silver)",
    "seller": "Aberg Best",
    "wholePrice": "35",
    "priceFraction": "00",
    "stock": 46,
    "star": 2,
    "starCount": 80,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51AasF06FwL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Aberg-Best-pixels-Digital-Camera/dp/B01N6E66RN/ref=sr_1_6?s=electronics&ie=UTF8&qid=1499124549&sr=1-6&keywords=camera",
    "features": [],
    "price": 35,
    "shipping": 3.99
}, {
    "key": "B01CG62D00",
    "category": "camera",
    "name": "Kodak PIXPRO Friendly Zoom FZ43 16 MP Digital Camera with 4X Optical Zoom and 2.7\" LCD Screen (Black)",
    "seller": "Kodak",
    "wholePrice": "66",
    "priceFraction": "40",
    "stock": 59,
    "star": 3,
    "starCount": 3095,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41XZUouAKJL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Kodak-PIXPRO-Friendly-Digital-Optical/dp/B01CG62D00/ref=sr_1_7?s=electronics&ie=UTF8&qid=1499124549&sr=1-7&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "2.7 inches"
    }, {
        "description": "Computer Memory Size",
        "value": "8 MB"
    }, {
        "description": "Hardware Interface",
        "value": "audio video port"
    }, {
        "description": "Display Technology",
        "value": "LCD"
    }, {
        "description": "Display Resolution Maximum",
        "value": "720p"
    }],
    "price": 66.4,
    "shipping": 3.99
}, {
    "key": "B01LWPSB57",
    "category": "camera",
    "name": "Camera Camcorders, Besteker HD 1080P 24MP 16X Digital Zoom Video Camcorder with 2.7\" LCD and 270 Degree Rotation Screen",
    "seller": "Besteker",
    "wholePrice": "53",
    "priceFraction": "99",
    "stock": 71,
    "star": 3,
    "starCount": 553,
    "img": "https://images-na.ssl-images-amazon.com/images/I/417uVGTgAlL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Camcorders-Besteker-Digital-Camcorder-Rotation/dp/B01LWPSB57/ref=sr_1_8?s=electronics&ie=UTF8&qid=1499124549&sr=1-8&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "2.7 inches"
    }, {
        "description": "Display Resolution Maximum",
        "value": "1920X1080"
    }, {
        "description": "Form Factor",
        "value": "rotating"
    }],
    "price": 53.99,
    "shipping": 3.99
}, {
    "key": "B01D93Z89W",
    "category": "camera",
    "name": "Canon EOS Rebel T6 Digital SLR Camera with 18-55mm EF-S f/3.5-5.6 IS II Lens + 58mm Wide Angle Lens + 2x Telephoto Lens + Flash + 48GB SD Memory Card + UV Filter Kit + Tripod + Full Accessory Bundle",
    "seller": "PHOTO4LESS",
    "wholePrice": "469",
    "priceFraction": "00",
    "stock": 10,
    "star": 4,
    "starCount": 2583,
    "img": "https://images-na.ssl-images-amazon.com/images/I/61heZtEPPBL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Canon-T6-Digital-Telephoto-Accessory/dp/B01D93Z89W/ref=sr_1_9?s=electronics&ie=UTF8&qid=1499124549&sr=1-9&keywords=camera",
    "features": [],
    "price": 469,
    "shipping": 7.99
}, {
    "key": "B01N0XDRYO",
    "category": "camera",
    "name": "KINGEAR Pcam PDC001 2.7 inch TFT LCD HD Mini Digital Camera(black)",
    "seller": "KINGEAR",
    "wholePrice": "46",
    "priceFraction": "99",
    "stock": 11,
    "star": 4,
    "starCount": 3908,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51uKiDibbZL._AC_US218_.jpg",
    "url": "https://www.amazon.com/KINGEAR-PDC001-2-7-Digital-Camera/dp/B01N0XDRYO/ref=sr_1_10?s=electronics&ie=UTF8&qid=1499124549&sr=1-10&keywords=camera",
    "features": [],
    "price": 46.99,
    "shipping": 3.99
}, {
    "key": "B01MRWZ4KL",
    "category": "camera",
    "name": "KINGEAR KG002 2.7 inch TFT LCD HD Mini Digital Camera",
    "seller": "GordVE",
    "wholePrice": "45",
    "priceFraction": "99",
    "stock": 24,
    "star": 4,
    "starCount": 3821,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51fNKzDjiyL._AC_US218_.jpg",
    "url": "https://www.amazon.com/KINGEAR-KG002-inch-Digital-Camera/dp/B01MRWZ4KL/ref=sr_1_11?s=electronics&ie=UTF8&qid=1499124549&sr=1-11&keywords=camera",
    "features": [],
    "price": 45.99,
    "shipping": 7.99
}, {
    "key": "B006J0SVWE",
    "category": "camera",
    "name": "Vivitar 20 MP Digital Camera with 1.8\" LCD, Colors and Style May Vary",
    "seller": "Vivitar",
    "wholePrice": "25",
    "priceFraction": "99",
    "stock": 17,
    "star": 2,
    "starCount": 4688,
    "img": "https://images-na.ssl-images-amazon.com/images/I/417t7EUvLpL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Vivitar-Digital-Camera-Colors-Style/dp/B006J0SVWE/ref=sr_1_12?s=electronics&ie=UTF8&qid=1499124549&sr=1-12&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "2.4 inches"
    }, {
        "description": "Display Type",
        "value": "LCD"
    }, {
        "description": "Form Factor",
        "value": "Compact"
    }],
    "price": 25.99,
    "shipping": 7.99
}, {
    "key": "B019UDHOMO",
    "category": "camera",
    "name": "Canon PowerShot ELPH 180 (Silver) with 20.0 MP CCD Sensor and 8x Optical Zoom",
    "seller": "Canon",
    "wholePrice": "119",
    "priceFraction": "00",
    "stock": 35,
    "star": 4,
    "starCount": 2898,
    "img": "https://images-na.ssl-images-amazon.com/images/I/418Z3vJAlEL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Canon-PowerShot-Silver-Sensor-Optical/dp/B019UDHOMO/ref=sr_1_13?s=electronics&ie=UTF8&qid=1499124549&sr=1-13&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "5 inches"
    }, {
        "description": "Hardware Interface",
        "value": "audio video port"
    }, {
        "description": "Display Technology",
        "value": "LCD"
    }, {
        "description": "Display Resolution Maximum",
        "value": "1"
    }, {
        "description": "Display Type",
        "value": "LCD"
    }],
    "price": 119,
    "shipping": 7.99
}, {
    "key": "B01M7V2FKC",
    "category": "camera",
    "name": "Mini Digital Camera,KINGEAR 2.7 inch TFT LCD HD Digital Camera(Black)",
    "seller": "KINGEAR",
    "wholePrice": "46",
    "priceFraction": "99",
    "stock": 29,
    "star": 4,
    "starCount": 1710,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51ILz01lxmL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Mini-Digital-Camera-KINGEAR-Black/dp/B01M7V2FKC/ref=sr_1_14?s=electronics&ie=UTF8&qid=1499124549&sr=1-14&keywords=camera",
    "features": [],
    "price": 46.99,
    "shipping": 3.99
}, {
    "key": "B071Z19L5T",
    "category": "camera",
    "name": "Nikon Coolpix L340 20.2 MP Digital Camera with 8GB memory card bundle (28x Optical Zoom, 3.0-Inch LCD, 720P Video, Black)",
    "seller": "Nikon",
    "wholePrice": "169",
    "priceFraction": "99",
    "stock": 99,
    "star": 0,
    "starCount": 1665,
    "img": "https://images-na.ssl-images-amazon.com/images/I/417bGBOCqBL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Nikon-Coolpix-L340-Digital-3-0-Inch/dp/B071Z19L5T/ref=sr_1_15?s=electronics&ie=UTF8&qid=1499124549&sr=1-15&keywords=camera",
    "features": [],
    "price": 169.99,
    "shipping": 3.99
}, {
    "key": "B01N6NDHPY",
    "category": "camera",
    "name": "PowerLead PLDH17 2.7 Inch TFT 5X Optical Zoom 15MP 1280 X 720 HD Anti-shake Smile Capture Digital Video Camera(Gold)",
    "seller": "PowerLead",
    "wholePrice": "65",
    "priceFraction": "99",
    "stock": 34,
    "star": 4,
    "starCount": 3490,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41lDD9GODtL._AC_US218_.jpg",
    "url": "https://www.amazon.com/PowerLead-Optical-Anti-shake-Capture-Digital/dp/B01N6NDHPY/ref=sr_1_16?s=electronics&ie=UTF8&qid=1499124549&sr=1-16&keywords=camera",
    "features": [],
    "price": 65.99,
    "shipping": 3.99
}, {
    "key": "B00THKEKEQ",
    "category": "camera",
    "name": "Nikon Coolpix L340 20.2 MP Digital Camera with 28x Optical Zoom and 3.0-Inch LCD (Black)",
    "seller": "Nikon",
    "wholePrice": "159",
    "priceFraction": "95",
    "stock": 91,
    "star": 4,
    "starCount": 2620,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41d0gUpd0eL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Nikon-Coolpix-Digital-Optical-3-0-Inch/dp/B00THKEKEQ/ref=sr_1_17?s=electronics&ie=UTF8&qid=1499124549&sr=1-17&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "3 inches"
    }, {
        "description": "Hardware Interface",
        "value": "audio video port"
    }, {
        "description": "Memory Storage Capacity",
        "value": "74 MB"
    }, {
        "description": "Display Type",
        "value": "TFT"
    }, {
        "description": "Form Factor",
        "value": "Compact"
    }],
    "price": 159.95,
    "shipping": 7.99
}, {
    "key": "B01MQIFINS",
    "category": "camera",
    "name": "Canon EOS Rebel T6 DSLR Camera Bundle with Canon EF-S 18-55mm f/3.5-5.6 IS II Lens + 2pc SanDisk 32GB Memory Cards + Accessory Kit",
    "seller": "Canon",
    "wholePrice": "465",
    "priceFraction": "00",
    "stock": 11,
    "star": 4,
    "starCount": 492,
    "img": "https://images-na.ssl-images-amazon.com/images/I/61j4LE9gOBL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Canon-18-55mm-3-5-5-6-SanDisk-Accessory/dp/B01MQIFINS/ref=sr_1_18?s=electronics&ie=UTF8&qid=1499124549&sr=1-18&keywords=camera",
    "features": [],
    "price": 465,
    "shipping": 7.99
}, {
    "key": "B01BMFXNQE",
    "category": "camera",
    "name": "iGadgitz PT310 Mini Lightweight Table Top Stand Tripod and Grip Stabilizer for Digital Camera, DSLR, Video Camera & Camcorder – Black",
    "seller": "igadgitz",
    "wholePrice": "15",
    "priceFraction": "99",
    "stock": 16,
    "star": 4,
    "starCount": 3033,
    "img": "https://images-na.ssl-images-amazon.com/images/I/411OpNYTMeL._AC_US218_.jpg",
    "url": "https://www.amazon.com/iGadgitz-Lightweight-Stabilizer-Digital-Camcorder/dp/B01BMFXNQE/ref=sr_1_19?s=electronics&ie=UTF8&qid=1499124549&sr=1-19&keywords=camera",
    "features": [],
    "price": 15.99,
    "shipping": 0
}, {
    "key": "B06XCMCFZW",
    "category": "camera",
    "name": "Digital Camera,KINGEAR 2.7 inch TFT LCD HD Digital Camera",
    "seller": "KINGEAR",
    "wholePrice": "43",
    "priceFraction": "99",
    "stock": 13,
    "star": 4,
    "starCount": 1587,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51OSpayWCLL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Digital-Camera-KINGEAR-2-7-inch/dp/B06XCMCFZW/ref=sr_1_20?s=electronics&ie=UTF8&qid=1499124549&sr=1-20&keywords=camera",
    "features": [],
    "price": 43.99,
    "shipping": 3.99
}, {
    "key": "B071G4XXZ4",
    "category": "camera",
    "name": "Btopllc On Dash Video Dash Cam Car Driving Video Recorder Camera 2.5 inch TFT LCD Screen USB Charging Vehicle Video Camera Loop Recording with Night Vision Car Dashboard Camera Recorder-Black",
    "seller": "Btopllc",
    "wholePrice": "18",
    "priceFraction": "95",
    "stock": 17,
    "star": 4,
    "starCount": 4025,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41JPzJ2V0RL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Btopllc-Recorder-Recording-Dashboard-Recorder-Black/dp/B071G4XXZ4/ref=sr_1_21?s=electronics&ie=UTF8&qid=1499124549&sr=1-21&keywords=camera",
    "features": [],
    "price": 18.95,
    "shipping": 7.99
}, {
    "key": "B00HE9G3UQ",
    "category": "camera",
    "name": "SGC-598 Photography Interview Shotgun MIC Microphone for Nikon Canon DSLR Camera (Need 3.5mm Interface)",
    "seller": "TAKSTAR",
    "wholePrice": "26",
    "priceFraction": "90",
    "stock": 45,
    "star": 3,
    "starCount": 1225,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51SRyF-I1aL._AC_US218_.jpg",
    "url": "https://www.amazon.com/SGC-598-Photography-Interview-Microphone-Interface/dp/B00HE9G3UQ/ref=sr_1_22?s=electronics&ie=UTF8&qid=1499124549&sr=1-22&keywords=camera",
    "features": [],
    "price": 26.9,
    "shipping": 3.99
}, {
    "key": "B00I8BIBCW",
    "category": "camera",
    "name": "Sony DSCW800/B 20.1 MP Digital Camera (Black)",
    "seller": "Sony",
    "wholePrice": "89",
    "priceFraction": "98",
    "stock": 37,
    "star": 3,
    "starCount": 3326,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41Huy05eJiL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Sony-DSCW800-Digital-Camera-Black/dp/B00I8BIBCW/ref=sr_1_24?s=electronics&ie=UTF8&qid=1499124549&sr=1-24&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "2.7 inches"
    }, {
        "description": "Display Fixture Type",
        "value": "Fixed"
    }, {
        "description": "Display Resolution Maximum",
        "value": "230000"
    }, {
        "description": "Memory Storage Capacity",
        "value": "29 MB"
    }, {
        "description": "Display Type",
        "value": "LCD"
    }],
    "price": 89.98,
    "shipping": 3.99
}, {
    "key": "B01MY0HQWS",
    "category": "camera",
    "name": "KINGEAR KG0016 2.7 Inch TFT 3X Optical Zoom 18MP 1280 X 720 Digital Video Camera",
    "seller": "GordVE",
    "wholePrice": "59",
    "priceFraction": "89",
    "stock": 97,
    "star": 4,
    "starCount": 2763,
    "img": "https://images-na.ssl-images-amazon.com/images/I/413kYxodmNL._AC_US218_.jpg",
    "url": "https://www.amazon.com/KINGEAR-KG0016-Optical-Digital-Camera/dp/B01MY0HQWS/ref=sr_1_25?s=electronics&ie=UTF8&qid=1499124549&sr=1-25&keywords=camera",
    "features": [],
    "price": 59.89,
    "shipping": 7.99
}, {
    "key": "B00RKNND2W",
    "category": "camera",
    "name": "Canon SX530 HS 9779B001 PowerShot",
    "seller": "Canon",
    "wholePrice": "249",
    "priceFraction": "00",
    "stock": 81,
    "star": 4,
    "starCount": 3147,
    "img": "https://images-na.ssl-images-amazon.com/images/I/412kGjEHJjL._AC_US218_.jpg",
    "url": "https://www.amazon.com/Canon-SX530-HS-9779B001-PowerShot/dp/B00RKNND2W/ref=sr_1_26?s=electronics&ie=UTF8&qid=1499124549&sr=1-26&keywords=camera",
    "features": [{
        "description": "Display Size",
        "value": "3 inches"
    }, {
        "description": "Display Fixture Type",
        "value": "Fixed"
    }, {
        "description": "Hardware Interface",
        "value": "audio video port"
    }, {
        "description": "Wireless Communication Technology",
        "value": "Yes"
    }, {
        "description": "Display Resolution Maximum",
        "value": "461000"
    }],
    "price": 249,
    "shipping": 0
}, {
    "key": "B06XGZB6P3",
    "category": "camera",
    "name": "Akaso EK7000 Ultra HD 4k WIFI 170 Degree Wide Waterproof Sports Action Camera Black + 32GB Outdoor Adventure Mounting Bundle",
    "seller": "AKASO",
    "wholePrice": "116",
    "priceFraction": "33",
    "stock": 31,
    "star": 4,
    "starCount": 4896,
    "img": "https://images-na.ssl-images-amazon.com/images/I/51xBO1ijxWL._AC_US218_.jpg",
    "url": "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_btf_electronics_sr_pg1_1?ie=UTF8&adId=A0699155IZEFEU9092Y5&url=https%3A%2F%2Fwww.amazon.com%2FEK7000-Waterproof-Outdoor-Adventure-Mounting%2Fdp%2FB06XGZB6P3%2Fref%3Dsr_1_27%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124549%26sr%3D1-27-spons%26keywords%3Dcamera%26psc%3D1&qualifier=1499124549&id=8228299164163419&widgetName=sp_btf",
    "features": [],
    "price": 116.33,
    "shipping": 0
}, {
    "key": "B06XRTN893",
    "category": "camera",
    "name": "Video Camera Camcorder, incoSKY 1080P 24MP 16X Digital Zoom Camera with 2.7\" TFT LCD 270 Degree Rotation Screen, Black",
    "seller": "incoSKY",
    "wholePrice": "49",
    "priceFraction": "99",
    "stock": 96,
    "star": 3,
    "starCount": 4565,
    "img": "https://images-na.ssl-images-amazon.com/images/I/41Ql6BycBCL._AC_US218_.jpg",
    "url": "https://www.amazon.com/gp/slredirect/picassoRedirect.html/ref=pa_sp_btf_electronics_sr_pg1_2?ie=UTF8&adId=A1008791K1VQMNSWD4IF&url=https%3A%2F%2Fwww.amazon.com%2FCamera-Camcorder-incoSKY-Digital-Rotation%2Fdp%2FB06XRTN893%2Fref%3Dsr_1_28%3Fs%3Delectronics%26ie%3DUTF8%26qid%3D1499124549%26sr%3D1-28-spons%26keywords%3Dcamera%26psc%3D1&qualifier=1499124549&id=8228299164163419&widgetName=sp_btf",
    "features": [{
        "description": "Display Size",
        "value": "2.7 inches"
    }, {
        "description": "Form Factor",
        "value": "rotating"
    }],
    "price": 49.99,
    "shipping": 7.99
}];

export default cameras;